import { render, staticRenderFns } from "./scorexsxfen.vue?vue&type=template&id=9c6dc23c&"
import script from "./scorexsxfen.vue?vue&type=script&lang=js&"
export * from "./scorexsxfen.vue?vue&type=script&lang=js&"
import style0 from "./scorexsxfen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports